import React, { useState } from "react";
import $ from "jquery";
import InProgress from "../../assets/images/In-Progress.png";
import Open from "../../assets/images/Open.png";
import Close from "../../assets/images/closed.png";
import { Link } from "react-router-dom";
import SkeletonContainer, { getSkeletonHeight } from "../../loaders/SekletonContainer";
import { BodySmall, Heading3, TextLink2 } from "../common/GlobalElements/Typography";
import { Card } from "../common/GlobalElements/Card";
import { StandardButton } from "../common/GlobalElements/StandardButton";

export default function ExamLeftBox(props) {
  const [examid, setExamId] = useState(props.examid);
  const [loading, setLoading] = useState(true);
  const [activeButton, setActiveButton] = useState(true);

  useState(() => {
    $("body").removeClass("hide-subject-sidebar");
  }, []);

  const { examListsRow } = props;

  setTimeout(() => {
    setLoading(false);
  }, 1000);

  const handleChildExamStatus = (status) => {
    if (status == "") {
      setActiveButton(true);
    } else {
      setActiveButton(false);
    }
    props.handleParentExamStatus(status);
  };

  const handleSideBar = () => {
    $("body").toggleClass("hide-subject-sidebar");
  };

  return (
    <>
      {loading && <SkeletonContainer height={getSkeletonHeight(4)} />}
      {!loading && (
        <div className="exam-detail-lft surface-background-color">
          <button className="close-btn-sidebar" onClick={() => handleSideBar()}>
            <i className="close-bar close-bar-1"></i>
            <i className="close-bar close-bar-2"></i>
            <i className="close-bar close-bar-3"></i>
          </button>
          <div className="exam-lft-head">
            <div className="all-exam">
              <TextLink2 to="/myexam">
                <i className="fal fa-angle-left"></i>All Exam
              </TextLink2>
            </div>

            <div className="exam-bx-info-top d-flex">
              <div className="icon">EP</div>
              <div className="exam-bx-info-right">
                <Heading3>
                  Exam Period <br />
                  {examListsRow?.period}
                </Heading3>
                <ul className="fa-ul ml-0">
                  <li className="d-flex">
                    <i className="fal fa-calendar-days mr-1"></i>
                   <BodySmall> {examListsRow?.startPriodTime && examListsRow?.endPriodTime ?  `${examListsRow?.startPriodTime} to ${examListsRow?.endPriodTime}` : "NA"} </BodySmall>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="exam-lft-body">
            <div className="exam-list-opt">
              <Card 
                padding="0.7rem"
                spacing={"10px"}
                alignItems={"center"}
                justifyContent={"space-between"}
                flexDirection={"row"}
                className="exam-list-opt-card"
                $position="relative"
                noAction={true}
                textAlign={"start"}
              >
                <div className="text-start">
                <BodySmall $marginBottom="10px">Your Status</BodySmall>

                <ul className="list-unstyled exam-reg-status m-0">
                  <li>
                    <i
                      className={`${examListsRow?.registrationStudentIcon} mr-1`}
                    ></i>
                    {examListsRow?.registrationStudentStatus ? examListsRow?.registrationStudentStatus : "NA"}
                  </li>
                </ul>
                </div>
                {examListsRow?.hideRegistrationButton ? (
                  examListsRow?.registrationStudentStatus == "Not Registered" ? (
                    examListsRow?.readOnly ? (
                      <StandardButton
                        variant="primary"
                        title="Register Now"
                        disabled={true}
                      >
                        <i className="fal fa-file-check"></i>Register Now
                      </StandardButton>
                    ) : (
                      <StandardButton
                        variant="primary"
                        title="Register Now"
                        className={`${!activeButton ? "btn-active" : ""}`}
                        onClick={() =>
                          handleChildExamStatus("new_registration")
                        }
                      >
                        <i className="fal fa-file-check"></i>Register Now
                      </StandardButton>
                    )
                  ) : (
                    <StandardButton
                      title="View"
                      variant="primary"
                      className={`btn ${
                        !activeButton ? "btn-active" : ""
                      }`}
                      onClick={() => handleChildExamStatus("viewed")}
                    >
                      <i className="fal fa-file-check"></i>View
                    </StandardButton>
                  )
                ) : null}
              </Card>

              <Card
                textAlign={"start"}
                padding="0.7rem"
                spacing={"10px"}
                alignItems={"center"}
                justifyContent={"space-between"}
                flexDirection={"row"}
                className="exam-list-opt-card"
                $position="relative"
                noAction={true}
              >
                <div>
                <BodySmall $marginBottom="10px">Registration Status</BodySmall>
                {examListsRow?.registrationStatus == "OPEN" ? (
                  <ul className="fa-ul list-unstyled exam-reg-status m-0">
                    <li>
                      <img src={Open} alt="Open" width="20px" height="20px" className="mr-1"/>
                      Open
                    </li>
                  </ul>
                ) : (
                  <ul className="fa-ul list-unstyled m-0">
                    <li className="text-start">
                        <img src={Close} alt="Closed" width="20px" height="20px" className="mr-1"/>
                      CLOSED
                    </li>
                  </ul>
                )}
                </div>

                <StandardButton
                  variant="dark"
                  title="Exam info"
                  className={`${activeButton ? "btn-active" : ""}`}
                  onClick={() => handleChildExamStatus("")}
                >
                  <i className="fal fa-info-circle"></i>Exam info
                </StandardButton>
              </Card>

              <Card
                padding="0.7rem"
                spacing={"10px"}
                alignItems={"flex-start"}
                textAlign={"start"}
                className="exam-list-opt-card"
                $position="relative"
                noAction={true}
              >
                <BodySmall $marginBottom="10px">Registration Close Date</BodySmall>
                <ul className="fa-ul list-unstyled m-0">
                  <li>
                    <i className="fal fa-calendar-days mr-1"></i>
                    {examListsRow?.registrationCloseDate ? examListsRow?.registrationCloseDate : "NA"}
                  </li>
                </ul>
              </Card>

              <Card
                padding="0.7rem"
                spacing={"10px"}
                alignItems={"flex-start"}
                className="exam-list-opt-card"
                $position="relative"
                noAction={true}
              >                
                <BodySmall $marginBottom="10px">Exam Status</BodySmall>
                <ul className="fa-ul list-unstyled m-0">
                  <li>
                    {examListsRow?.exam_status_text == "IN PROGRESS" ? (
                      <React.Fragment>
                        <img src={InProgress} alt="In-Progress" width="20px" height="20px" className="mr-1"/>
                        In-Progress
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <img src={Close} alt="Closed" width="20px" height="20px" className="mr-1"/>
                        CLOSED
                      </React.Fragment>
                    )}
                  </li>
                </ul>
              </Card>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
